import { render, staticRenderFns } from "./cinder.vue?vue&type=template&id=4fb45476&"
import script from "./cinder.vue?vue&type=script&lang=js&"
export * from "./cinder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports